import { render, staticRenderFns } from "./Accounts2.vue?vue&type=template&id=0b1af5be&scoped=true&"
import script from "./Accounts2.vue?vue&type=script&lang=js&"
export * from "./Accounts2.vue?vue&type=script&lang=js&"
import style0 from "./Accounts2.vue?vue&type=style&index=0&id=0b1af5be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1af5be",
  null
  
)

export default component.exports